import { render, staticRenderFns } from "./simOpenWu.vue?vue&type=template&id=506885be&scoped=true&"
import script from "./simOpenWu.vue?vue&type=script&lang=js&"
export * from "./simOpenWu.vue?vue&type=script&lang=js&"
import style0 from "./simOpenWu.vue?vue&type=style&index=0&id=506885be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506885be",
  null
  
)

export default component.exports